/**
 * Tests if an object is reasonably a Stream object... Not perfect, but should be
 * good enough.
 *
 * This method is a bit unreliable and may need to be updated from time to time
 * if it doesn't work...  This broke recently on us when webpack changed their
 * NodeJS shim object hierarchy to not have {Stream} as the root...
 *
 * @param {*} obj - The object to test.
 * @returns {boolean} - True if it is a {Stream} like object.
 */
exports.isStream = function (obj) {
  const stream = require('stream');

  // Do an instanceof check as a shortcut, this should work from node
  const isInstanceOfStream = obj instanceof stream.Stream;

  // Additionally test the object structure and if it has a pipe function, this should work
  // in the browser.
  return isInstanceOfStream || (typeof obj === 'object' && typeof obj.pipe === 'function');
};
